const testMediumDisplayMap = {
  'Tribyte': 'Tribyte',
  'Test_Platform': 'Test platform'
}

export const getTestMediumDisplayValue = (testMedium) => testMediumDisplayMap?.[testMedium];